<template>
  <div>
    <h1><b-avatar size="1.5rem" :text="getIniziali(user)"></b-avatar> Il tuo profilo</h1>
    Nome: {{ user.first_name }}<br />
    Cognome: {{ user.last_name }}<br />
    Organizzazione: {{ user.organization }}<br />
    email: {{ user.email }}<br />
  </div>
</template>

<script>
import authHeader from "@/services/auth-header";
import util from "@/mixing/util";
import User from "@/models/user";

export default {
  name: "Profile",
  mixins: [util],
  data() {
    return {
      user: new User("", ""),
    };
  },
  mounted() {
    this.axios
      .get(process.env.VUE_APP_ROOT + "/users/whoami.json", { headers: authHeader() })
      .then((response) => {
        this.user = response.data;
        if (this.user.dest_lang_id.length > 0) {
          this.$router.push(`/translators/view/${this.user.id}`);
        }
      })
      .catch((error) => {
        console.log("Whoami: error");
        console.log(error);
        this.$store.dispatch("auth/logout");
        this.$router.push("/login");
      });
  },
};
</script>
